import * as React from 'react';
import { Outlet , useNavigate} from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import { 
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Button
 } from '@mui/material';
 
import { Confirmation } from '../utils';
import { CONST, TokenValidator } from '../../utils';
import NavigationActions from '../navigationActions';

export default function Holder() {
    document.title = 'Production Management';
    const nav = useNavigate();
    
    const [logoutUi, showUi] = React.useState(false);
    const [loged, isLoged] = React.useState(false);
    
    React.useEffect(() => {
        AdquireToken();
    },[]);

    const LoginContext = {
        didLogin : isLoged
    }

    const HolderContex = {
        Login : LoginContext
    }

    const logout = async() => {
        CONST.PM_LOGOUT_KEYS.forEach(x => {
            localStorage.removeItem(x);
        })
        showUi(false);
        isLoged(false);
        nav('', {replace: true});
    }   

    const AdquireToken = async() => {
        const result = await TokenValidator.GetInternalUser();

        if(result == null){
            nav('/productionmanagement', {replace: true});
            return;
        }

        const valid = await TokenValidator.ValidTokenDate(result);

        if(!valid){
            nav('/productionmanagement', {replace: true});
            return;
        }

        isLoged(true);
    }

    return(
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            <AppBar 
                position='static'
            >
                <Toolbar
                    sx={{
                        gap: 2
                    }}
                >
                <NavigationActions />

                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    PRODUCTION MANAGEMENT
                </Typography>

                {loged && (
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={() => showUi(true)}
                    >
                        <LogoutIcon />
                    </IconButton>
                )}

                
                </Toolbar>
            </AppBar>
            
            <Confirmation 
                open={logoutUi} 
                onClose={() => showUi(false)} 
                onConfirm={(logout)} 
                title={'Log Out'} 
                msg={'Please, confirm to logout from Production Management Portal'}
            />

            <Box sx={{ display: "flex", flexGrow: 1 }}>
                <Outlet context={HolderContex}/>
            </Box>
        </Box>
    );
}
